require('jquery-tokeninput');
require('webpack-jquery-ui/datepicker');
require('jquery-timepicker/jquery.timepicker');

import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle";
import { TokenList } from '../ui/token_list'
import { DataSender } from '../loaders'
/**
* TicketsEditor
*/
var CurrencyMinimumPrice = [
    null,
    1.00, // BGN
    1.00, // GBP
    1.00 // EUR
];

class TicketsEditor {
    constructor(target, options) {
        if(!target || !target.length) return;
        if(!options) options = {};

        this.MAXIMUM_CATEGORIES_LIMIT = 20
        this.MAXIMUM_REQUIRED_PIECES_OF_INFORMATION = 10
        this.CATEGORIES_COLORS = ['#005C11','#429506','#69CE22','#FFD800','#FF9D00','#FF5722','#F23123','#AE1D11','#9C1F80','#7E1F9D','#1E399C','#2284D1','#23C3D0','#4FEAFF','#009688','#26D094','#795548','#617D8B','#9E9E9E','#113242'];

        // properties
        this.target = target;
        this.texts = options.texts;
        this.venuesBaseUrl = options.venues_base_url;

        this.categoriesCount = 0;
        this.categoriesTemplates = {
            'free': null,
            'paid': null
        };
        this.categoriesColors = this.CATEGORIES_COLORS.concat();
        this.categoriesDisabledColors = [];

        this.sections = {'sections':[]};

        // init
        this.initLayout();
    }

// DATA

    serializeData() {
        var data = {
            id: this.ticketsId.val(),
            currency_id: this.currency.val(),
            age_restriction: this.ageRestriction.length & this.ageRestriction.is(':checked') ? 1 : 0,
            require_registration: this.requireRegistration.length && this.requireRegistration.is(':checked') ? 1 : 0,
            hide_quantity_left: this.hideRemaining.length && this.hideRemaining.is(':checked') ? 1 : 0,
            venue_url: this.venuesUrl.val(),
            categories: [],
            sections: this.sections,
            tax_rate: this.includeTaxes.is(':checked') ? this.taxRate.val() : 0,
            tax_label: this.includeTaxes.is(':checked') ? this.taxLabel.val() : null
        };

        this.categoriesList.find('.card').each(function() {
            var category = $(this);
            var id = parseInt(category.data('id'));
            var locked = Boolean(category.data('locked'));
            var type = category.data('type');
            
            if(locked) {
                data.locked = 1;
                data.categories.push({
                    id: id,
                    locked: 1,
                    type: type,
                    free: (type == 'free') ? 1 : 0,
                    color: category.data('color'),
                    name: category.find('.name').find('input').val(),
                    remaining: category.find('fieldset.quantity').find('span.label').text(),
                    price: (type == 'free') ? null : category.find('fieldset.price').find('span.label').text(),
                    active: category.find('.active').find('input').is(':checked') ? 1 : 0,
                    start_at: category.find('.options').find('.sales-period.start').find('input.left').val(),
                    start_time: category.find('.options').find('.sales-period.start').find('input.right').val(),
                    end_at: category.find('.options').find('.sales-period.end').find('input.left').val(),
                    end_time: category.find('.options').find('.sales-period.end').find('input.right').val(),
                    description: category.find('.options').find('.description').find('input').val(),
                    limit_per_user: (type == 'free') ? parseInt(category.find('.options').find('.limit').find('select').val()) : 0,
                    required_information: JSON.parse('{"items": [' + category.find('input[name="ticket-category-information[]"]').val().replace(/'/g, '"') + ']}').items,
                    section: category.find('.section select').val()
                });
            }
            else {
                data.categories.push({
                    id: (id) ? id : null,
                    locked: locked,
                    type: type,
                    color: (!locked) ? category.data('color') : null,
                    name: category.find('.name').find('input').val(),
                    quantity: (!locked) ? parseInt(category.find('.quantity').find('input').val()) : null,
                    price: (type == 'paid' && !locked) ? parseFloat(category.find('.price').find('input').val()) : null,
                    active: category.find('.active').find('input').is(':checked') ? 1 : 0,
                    start_at: category.find('.options').find('.sales-period.start').find('input.left').val(),
                    start_time: category.find('.options').find('.sales-period.start').find('input.right').val(),
                    end_at: category.find('.options').find('.sales-period.end').find('input.left').val(),
                    end_time: category.find('.options').find('.sales-period.end').find('input.right').val(),
                    description: category.find('.options').find('.description').find('input').val(),
                    limit_per_user: (type == 'free') ? parseInt(category.find('.options').find('.limit').find('select').val()) : 0,
                    required_information: JSON.parse('{"items": [' + category.find('input[name="ticket-category-information[]"]').val().replace(/'/g, '"') + ']}').items,
                    section: category.find('.section select').val()
                });
            }
        });

        return data;
    }

    checkData() {
        var data = this.serializeData();

        if(!data.categories.length) {
            this.ticketsData.val('');
            this.ticketsSave.val(0);
            return true;
        }

        var items = this.categoriesList.find('.card');

        for(var i in data.categories) {
            var category = items.eq(i);
            var locked = category.data('locked');
            var ticket = data.categories[i];

            if(!ticket.name.length) {
                this.scrollToCategory(category);
                category.find('.name').highlight('red', { hideEvent: 'click', text: this.texts.noNameError });
                return false;
            }

            if(!locked) {

                if(!ticket.locked && (isNaN(ticket.quantity) || ticket.quantity < 1 || ticket.quantity > 9999)) {
                    this.scrollToCategory(category);
                    category.find('.quantity').highlight('red', { hideEvent: 'click', text: this.texts.noQuantityError });
                    return false;
                }


                if(ticket.type == 'paid') {

                    if(!ticket.locked && (isNaN(ticket.price) || ticket.price < 0.01 || ticket.price > 2499.99)) {
                        this.scrollToCategory(category);
                        category.find('.price').highlight('red', { hideEvent: 'click', text: this.texts.noPriceError });
                        return false;
                    }


                    if(!ticket.locked && ticket.price < CurrencyMinimumPrice[data.currency_id]) {
                        this.scrollToCategory(category);
                        category.find('.price').highlight('red', { hideEvent: 'click', text: this.texts.priceMinumumError.replace(/%s/, $.trim(this.getCurrencySymbol().format)).replace(/%s/, CurrencyMinimumPrice[data.currency_id].toFixed(2)) });
                        return false;
                    }
                }


                if(ticket.start_at && ticket.end_at) {
                    var sd = ticket.start_at.split('.');
                    var st = ticket.start_time.split(':');
                    var ed = ticket.end_at.split('.');
                    var et = ticket.end_time.split(':');
                    var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
                    var startTimestamp = Math.floor((new Date(sd[2], sd[1] - 1, sd[0], st[0], st[1], 0, 0).getTime() - timezoneOffset) / 1000);
                    var endTimestamp   = Math.floor((new Date(ed[2], ed[1] - 1, ed[0], et[0], et[1], 0, 0).getTime() - timezoneOffset) / 1000);

                    if(startTimestamp >= endTimestamp) {
                        this.scrollToCategory(category);
                        category.find('.options').highlight('red', { hideEvent: 'click', offset: [0, 15], text: this.texts.startBeforeEndDateError });
                        return false;
                    }
                }
            }
        }

        this.ticketsData.val(JSON.stringify(data));
        this.ticketsSave.val(1);
        return true;
    }

// LAYOUT

    initLayout() {
        var that = this;

        // general
        this.settings = this.target.find('.settings');

        this.currency = this.settings.find('select[name="tickets-currency"]');
        this.currency.bind('change', function() {
            that.changeCurrencySymbol(that.categoriesList.find('.card[data-type="paid"]'));
        });
        
        this.taxRate = this.settings.find('input[name="tickets-tax-rate"]').floatInput();
        this.taxLabel = this.settings.find('input[name="tickets-tax-label"]');

        // checkboxes
        this.ageRestriction = this.settings.find('input[name="tickets-age-restriction"]');
        this.requireRegistration = this.settings.find('input[name="tickets-require-registration"]');
        this.hideRemaining = this.settings.find('input[name="tickets-hide-quantity-left"]');
        this.includeTaxes = this.settings.find('input[name="tickets-include-taxes"]');
        
        if (this.taxRate.val() && this.taxLabel.val()) {
            this.includeTaxes.prop('checked', 'checked');
            $('div.tax').show();
        } else $('div.tax').hide();

        this.includeTaxes.bind('click', function() {
            if ($(this).is(":checked")) {
                $('div.tax').show();
                $('div.tax').find('input').each(function() {
                    $(this).attr('required', 'required');
                });
            } else {
                $('div.tax').hide();
                $('div.tax').find('input').each(function() {
                    $(this).removeAttr('required');
                });
            }
        });

        this.venuesUrl = $('#venue-url'); //this.settings.find('input[name="tickets-venue-url"]');
        $(this.venuesUrl).bind('change', function(e) {
            $.ajax({
                async: true,
                dataType: 'json',
                type: 'get',
                url: that.venuesBaseUrl+that.venuesUrl.val()+`/seats.json`,
                crossDomain: true,
                success: function(data){
                    that.sections = data['sections'];
                    $(that.sections).each(function(i){
                        var count = 0;
                        $(that.sections[i]['rows']).each(function(j){
                            for (var k = 0; k < that.sections[i]['rows'][j].length; k++) {
                              if (that.sections[i]['rows'][j][k] == 1) count++;
                            }
                        });
                        that.sections[i]['count'] = count;
                    });
                },
                error: function(e){
                    console.log(e)
                }
            })
        })
        if(this.venuesUrl.val()!=""){
            this.venuesUrl.change()   
        }

        // categories
        this.categoriesList = this.target.find('div.categories');
        this.categoriesList.find('div.card').each(function() {
            that.categoriesCount++;

            if(that.categoriesCount == that.MAXIMUM_CATEGORIES_LIMIT) {
                that.buttons.addClass('limit-reached');
            }

            that.initCategory($(this), false);
        });

        // buttons
        this.buttons = this.target.find('.buttons');

        this.addButtons = this.buttons.find('a');
        this.addButtons.bind('click', function() {
            if(!$(this).hasClass('disabled')) {
                that.addCategory($(this).data('type'));
            }
            return false;
        });

        this.maximumCategoriesLimit = this.buttons.find('div');
        this.maximumCategoriesLimit.text(this.maximumCategoriesLimit.text().replace(/%d/, this.MAXIMUM_CATEGORIES_LIMIT));

        // hidden inputs
        this.ticketsId = this.target.find('input[name="tickets-id"]');
        this.ticketsSave = this.target.find('input[name="tickets-save"]');
        this.ticketsData = this.target.find('input[name="tickets-data"]');
    }

    getCurrencySymbol() {
        var selected = this.currency.find('option:selected');

        return {
            prefix: parseInt(selected.data('prefix')) == 1,
            symbol: selected.data('symbol'),
            format: selected.data('format')
        };
    }

    changeCurrencySymbol(item) {
        var legend = item.find('.price').find('legend');

        if(legend.data('format')) {
            legend.html(legend.data('format').replace(/%s/, $.trim(this.getCurrencySymbol().symbol)));
        }
    }

    lightenLegend(input) {
        input.bind('input', function() {
            if(input.val().length) {
                input.parent().find('legend').addClass('light');
            }
            else {
                input.parent().find('legend').removeClass('light');
            }
        });

        input.trigger('input');
    }

    scrollToEditor() {
        $('html, body').animate({ scrollTop: $('div.tickets-editor').position().top }, { duration: 200 });
    }

    scrollToCategory(category) {
        $('html, body').animate({ scrollTop: category.position().top - 80 }, { duration: 200 });
    }

// CATEGORIES

    addCategory(type, transition) {
        var that = this;

        if(this.categoriesCount < this.MAXIMUM_CATEGORIES_LIMIT) {
            this.categoriesCount++;

            if(this.categoriesCount == this.MAXIMUM_CATEGORIES_LIMIT) {
                this.buttons.addClass('limit-reached');
            }

            if(this.categoriesTemplates[type]) {
                this.initCategory($(this.categoriesTemplates[type]).appendTo(this.categoriesList), true);
                this.target.addClass('added-categories');
            }
            else {
                var button = this.addButtons.filter('[data-type="' + type + '"]');
                button.addClass('loading');
                button.data('text', button.text());
                button.html('<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>');

                new DataSender({
                    data: { type: type, sections: that.sections },
                    url: '/event/tickets/category/',

                    success: function(data) {
                        if(data.status) {
                            that.categoriesTemplates[type] = data.html;
                            that.initCategory($(data.html).appendTo(that.categoriesList), true);

                            button.removeClass('loading').text(button.data('text'));
                            that.target.addClass('added-categories');


                        }
                    },
                    error: function(e){
                        console.log(e)
                    }
                });
            }
        }
    }

    initCategory(category, newCategory) {
        var that = this;
        var locked = Boolean(category.data('locked'));

        // color
        // if(!locked) {
        //     category.bind('click', function() {
        //         category.colorPicker({
        //             colors: that.CATEGORIES_COLORS,
        //             disabledColors: that.categoriesDisabledColors,
        //             placement: 'left',
        //             selectedColor: category.data('color'),

        //             select: function(selectedColor) {
        //                 index = $.inArray(selectedColor, that.categoriesColors);
        //                 if(index > -1) that.categoriesColors.splice(index, 1);

        //                 index = $.inArray(category.data('color'), that.categoriesDisabledColors);
        //                 if(index > -1) that.categoriesDisabledColors.splice(index, 1);

        //                 that.categoriesColors.push(category.data('color'));
        //                 that.categoriesDisabledColors.push(selectedColor);

        //                 category.data('color', selectedColor);
        //                 category.css('border-color', selectedColor);
        //             }
        //         });
        //     });
        // }

        if(category.data('color') && $.inArray(category.data('color'), this.CATEGORIES_COLORS) > -1) {
            this.categoriesColors.splice($.inArray(category.data('color'), this.categoriesColors), 1);
            this.categoriesDisabledColors.push(category.data('color'));
        }
        else {
            var selectedColor = this.categoriesColors.shift();
            this.categoriesDisabledColors.push(selectedColor);

            category.data('color', selectedColor);
        }

        category.css('border-left', "solid 5px " + category.data('color'));

        // name
        var name = category.find('.name').find('input');
        this.lightenLegend(name);

        // quantity
        if(!locked) {
            var quantity = category.find('.quantity').find('input').integerInput();
            quantity.bind('blur', function() {
                if(quantity.val()) {
                    if(quantity.val() < 1) {
                        quantity.val(1);
                    }
                    else if(quantity.val() > 9999) {
                        quantity.val(9999);
                    }
                    else {
                        quantity.val(parseInt(quantity.val()));
                    }
                }
            });

            this.lightenLegend(quantity);
        }

        // price
        if(category.data('type') == 'paid') {
            if(!locked) {
                var price = category.find('.price').find('input').floatInput();
                price.bind('blur', function() {
                    if(price.val()) {
                        if(price.val() < 0.01) {
                            price.val(0.01);
                        }
                        else if(price.val() > 2499.99) {
                            price.val(2499.99);
                        }
                        else {
                            price.val(parseFloat(price.val()).toFixed(2));
                        }
                    }
                });

                this.lightenLegend(price);
            }

            this.changeCurrencySymbol(category);
        }

        // active
        var active = category.find('.active').find('input');
        active.bind('change', function() {
            var checkbox = $(this);

            if(checkbox.is(':checked')) {
                checkbox.parent().parent().highlight('green', { hideEvent: 'mouseleave', offset: [10, 0], placement: 'left', text: that.texts.activeCategory });
            }
            else {
                checkbox.parent().parent().highlight('yellow', { hideEvent: 'mouseleave', offset: [10, 0], placement: 'left', text: that.texts.inactiveCategory });
            }
        });

        // delete
        if(!locked && !parseInt(category.data('id'))) {
            category.find('.delete').find('a').bind('click', function() {
                that.removeCategory(category);
                return false;
            });
        }

        // toggle options
        var options = category.find('.options');
        var toggleTabindex = function() {
            if(options.hasClass('d-none')) {
                options.find('input').prop('tabindex', -1);
                options.find('select').prop('tabindex', -1);
            }
            else {
                options.find('input').removeProp('tabindex');
                options.find('select').removeProp('tabindex');
            }
        };

        category.children('.toggle-options').bind('click', function() {
            $(this).toggleClass('toggled');
            options.toggleClass('d-none');
            toggleTabindex();
            return false;
        });

        toggleTabindex();

        // sales
        var salesStartDate = options.find('.sales-period.start').find('input[name="ticket-start-date[]"]');
        var salesStartTime = options.find('.sales-period.start').find('input[name="ticket-start-time[]"]');
        var salesEndDate = options.find('.sales-period.end').find('input[name="ticket-end-date[]"]');
        var salesEndTime = options.find('.sales-period.end').find('input[name="ticket-end-time[]"]');

        salesStartDate.datepicker({
            dateFormat: window.evedo.dateFormat,
            weekStart: 1,
            onSelect: function(e) {
                // salesStartDate.datepicker('hide');

                if(salesStartTime.val() == '') {
                    salesStartTime.val('00:00');
                }
            }
        });

        var salesStartTimeValue = salesStartTime.val();
        salesStartTime.timepicker({ defaultValue: 'value', showMeridian: false });
        if(salesStartTimeValue) { salesStartTime.val(salesStartTimeValue); }

        salesEndDate.datepicker({
            dateFormat: window.evedo.dateFormat,
            weekStart: 1,
            onSelect: function(e) {
                // salesEndDate.datepicker('hide');

                if(salesEndTime.val() == '') {
                    salesEndTime.val('23:59');
                }
            }
        });

        var salesEndTimeValue = salesEndTime.val();
        salesEndTime.timepicker({ defaultValue: 'value', showMeridian: false });
        if(salesEndTimeValue) { salesEndTime.val(salesEndTimeValue); }

        var tooltipTriggerList = [].slice.call(options.find('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

        // required information
        var requiredInformation = options.find('.required-information');
        var select = requiredInformation.find('select');
        var tokenList = requiredInformation.find('ul.token-list');

        tokenList = new TokenList(tokenList, 'ticket-category-information[]', {
            limit: this.MAXIMUM_REQUIRED_PIECES_OF_INFORMATION,
            prepend: true,

            changed: function(result) {
                if(result.limitReached) {
                    if(select.length) {
                        select.prop('disabled', 'disabled');
                    }
                }
                else {
                    if(select.length) {
                        select.removeProp('disabled');
                    }
                }
            }
        });

        if(!locked) {
            select.bind('change', function() {
                var label = $(this).find('option:selected').text();
                var value = $(this).val();

                if(value.length) {
                    if($.inArray(value, ['full_name', 'email', 'tshirt', 'age', 'gender', 'phone']) > -1) {
                        tokenList.add({
                            label: label,
                            remove: true,
                            special: true,
                            value: JSON.stringify({
                                type: 'default',
                                field_type: value
                            }).replace(/"/g, "'")
                        });
                    }
                    else if(value == 'custom') {
                        var customLabel = $.trim(window.prompt(that.texts.addCustomQuestion)).replace(/["|']/g, '');

                        if(customLabel.length) {
                            tokenList.add({
                                label: customLabel,
                                remove: true,
                                value: JSON.stringify({
                                    type: 'custom',
                                    field_type: 'input',
                                    field_label: customLabel
                                }).replace(/"/g, "'")
                            });
                        }
                    }

                    select.find('option:first').attr('selected', 'selected');
                }
            });
        }
        else {
            select.prop('disabled', 'disabled');
        }


        var seatingSection = options.find('.section');
        var select = seatingSection.find('select');

        if (!locked) {
            select.bind('change', function(){
                var i = select.val();
                var name = select.find('option:selected').text()
                var quantity = category.find('.quantity').find('input');
                var name = category.find('.name').find('input');

                if (that.sections[i]['count'] >= 0){
                    name.val(that.sections[i]['name']);
                    quantity.val(that.sections[i]['count']);
                } else {
                    name.val('');
                    quantity.val('');
                }
            })
        }

        // init
        this.categoriesList.css('overflow', 'hidden');

        window.setTimeout(function() {
            category.removeClass('hidden-right');
        }, 10);

        window.setTimeout(function() {
            that.categoriesList.css('overflow', 'visible');

            if(newCategory) {
                name.focus();
            }
        }, 500);
    }

    removeCategory(category) {
        var that = this;

        if(
            category.find('input[name="ticket-category-name[]"]').val() ||
            category.find('input[name="ticket-category-quantity[]"]').val() ||
            category.find('input[name="ticket-category-price[]"]').val() ||
            category.find('input[name="ticket-category-description[]"]').val()
        ) {
            if(!window.confirm((category.data('id')) ? this.texts.deleteConfirm : this.texts.progressConfirm)) {
                return;
            }
        }

        if(this.categoriesCount) {
            this.categoriesCount--;

            // var color = category.find('.color');

            // index = $.inArray(color.data('color'), this.categoriesDisabledColors);
            // if(index > -1) this.categoriesDisabledColors.splice(index, 1);
            // this.categoriesColors.push(color.data('color'));

            if(!this.categoriesCount) {
                category.remove();
                this.target.removeClass('added-categories');
            }
            else {
                category.addClass('hidden-right');
                // color.removeColorPicker();

                this.categoriesList.css('overflow', 'hidden');

                window.setTimeout(function() {
                    category.remove();
                    that.categoriesList.css('overflow', 'visible');
                }, 400);
            }

            this.buttons.removeClass('limit-reached');
        }
    }
}

export { TicketsEditor }
